export const DEFAULT_COLUMN_WIDTH = 'minmax(0, 1fr)'

export const getGridTemplateColumns = (
  columnIds: string[],
  columnWidths: Partial<Record<string, string>>
) => columnIds.map((id) => columnWidths[id] ?? DEFAULT_COLUMN_WIDTH).join(' ')
